// extracted by mini-css-extract-plugin
export default {"footer":"ui_footer__4jimi","content":"ui_content__zwtZi","results":"ui_results__3Ch9k"};